import { render, staticRenderFns } from "./AdminSectionHeader.vue?vue&type=template&id=0d2bb79c&scoped=true&"
import script from "./AdminSectionHeader.vue?vue&type=script&lang=js&"
export * from "./AdminSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdminSectionHeader.vue?vue&type=style&index=0&id=0d2bb79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2bb79c",
  null
  
)

export default component.exports